<template>
  <section id="screener" class="container-fluid">
    <header class="header-wrapper">
      <h1 class="text-center text-4xl p-3 text-gray-600">銘柄スクリーナー</h1>

      <div v-show="!loading" class="flex">
        <div class="pl-5">
          <el-button @click="dialog.visible = true" type="success" plain icon="el-icon-setting">
            <svg style="width:24px;height:20px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
            </svg> 表示項目と条件の設定
          </el-button>
        </div>
        <div class="pl-2">
          <el-dropdown @command="dataDownload">
            <el-button :disabled="loading || filtered_stockDataLength === 0" type="success"  plain icon="el-icon-setting">
              <svg style="width:24px;height:20px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
              </svg> 銘柄コードのリストをダウンロード<el-icon class="el-icon--right"></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="all">全件分{{`（${filtered_stockDataLength}件）`}}</el-dropdown-item>
                <el-dropdown-item command="part">現在の表示件数分のみ</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <el-row v-show="!loading" class="text-2xl p-2 pl-5 pt-4">
        <el-col>
          全 <strong>{{ moneyDelimiter(filtered_stockDataLength) }}</strong> 件
          &nbsp;{{ pageStart }} - {{ pageEnd }} 件目表示
        </el-col>
      </el-row>
    </header>
    <!-- pagination -->
    <div class="pagination p-2 pl-10">
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageCurrentChange"
        :page-sizes="[20, 50, 100, 500]"
        :page-size="pageSize"
        v-model:current-page="pageCurrent"
        :total="filtered_stockDataLength"
        layout="sizes, pager"
        background>
      </el-pagination>
    </div>

    <!-- テーブル
      ________________________________________________________________ -->
    <template v-if="filtered_stockDataLength">
      <div class="pl-5">
        <table>
          <thead>
            <tr>
              <th
                v-for="(mylist, idx) in save.myDisp"
                :key="`${mylist.item}_head_${idx}`"
                :style="{
                  minWidth: widthCell[mylist.item] + 'px',
                  maxWidth: widthCell[mylist.item] + 'px',
                }"
                height="40"
                class="px-2 py-1 sticky top-0 z-50 bg-white">
                {{ dialog.dispItemList[mylist.item].head }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(stock, stockIdx) in tableStockData"
              :key="`stock_${stockIdx}`"
              :style="{ backgroundColor: (stockIdx % 2 == 1) ? '#fafafa' : '' }"
              class="bg-white even:bg-gray-200">
              <td
                v-for="(mylist, idx) in save.myDisp"
                :key="`${mylist.item}_body_${idx}`"
                :class="[
                  (mylist.item == 'brand_name') ? 'text-no-wrap' : 'no-wrap',
                  (dialog.dispItemList[mylist.item].type === 'text' ) ? 'text-left' : 'text-right',
                  pickHeatMapColor(mylist.item, stock[mylist.item])
                ]"
                :style="{
                  minWidth: widthCell[mylist.item] + 'px',
                  maxWidth: widthCell[mylist.item] + 'px',
                }"
                height="40"
                class="border px-2 py-1">
                <template v-if="mylist.item == 'brand_name'">
                  <el-tooltip effect="dark" :content="stock[mylist.item]" placement="top">
                    <span class="text-sm md:text-xl">{{ stock[mylist.item] }}</span>
                  </el-tooltip>
                </template>
                <template v-else>
                  <span class="text-xl">
                    {{ cellValue(mylist.item, stock[mylist.item]) }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- pagination -->
      <div class="pagination p-2 pl-10">
        <el-pagination
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
          :page-sizes="[20, 50, 100, 500]"
          :page-size="pageSize"
          v-model:current-page="pageCurrent"
          :total="filtered_stockDataLength"
          layout="sizes, pager"
          background>
        </el-pagination>
      </div>
    </template>

    <!-- 設定ダイアログ
      ________________________________________________________________ -->
    <el-dialog
      v-model="dialog.visible"
      :before-close="dialogClose"
      :width="( getResponsive == 'sm' ) ? '768px' : '100vw'"
    >
      <div class="text-center text-3xl font-bold pb-2">
        <span class="dialog-title">表示項目と条件の設定</span>
      </div>
      <!-- ダイアログ ソート設定 -->
      <div class="table-responsive">
        <table class="table table-hover">
          <div>
            <thead>
              <tr class="dialog-tr grid gap-x-2 grid-cols-12 justify-items-auto py-2">
                <th class="col-span-1"/>
                <th class="text-xl font-bold col-span-3">並び替える項目</th>
                <th class="text-xl font-bold col-span-3">並び替える順序</th>
                <th class="col-span-4"/>
                <th class="col-span-1"/>
              </tr>
            </thead>
          </div>
          <hr>
          <tbody>
            <tr class="dialog-tr grid gap-x-2 grid-cols-12 justify-items-auto py-2">
              <!-- ドラッグアイコン -->
              <td class="col-span-1"></td>
              <!-- 並び替える項目 -->
              <div class="col-span-3">
                <td>
                  <el-select
                    v-model="tmp.mySort.item"
                    popper-class="sc_select"
                    placeholder="選択">
                    <el-option
                      v-for="item in sortItemList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </td>
              </div>
              <!-- 並び替える順序 -->
              <div class="col-span-3">
                <td>
                  <el-select
                    v-if="tmp.mySort.item"
                    v-model="tmp.mySort.order"
                    placeholder="選択">
                    <el-option
                      v-for="item in dialog.sortOrderList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </td>
              </div>
              <!-- 表示する条件 詳細 -->
              <div class="col-span-4">
                <td>
                </td>
              </div>
              <div class="col-span-1 justify-self-end mr-5">
                <td>
                </td>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- ダイアログ 表示設定 -->
      <div class="table-responsive">
        <table class="table table-hover">
          <div>
            <thead>
              <tr class="dialog-tr grid gap-x-2 grid-cols-12 justify-items-auto py-2">
                <th class="col-span-1"/>
                <th class="text-xl font-bold col-span-3">表示する項目</th>
                <th class="text-xl font-bold col-span-3">表示する条件</th>
                <th class="col-span-4"/>
                <th class="col-span-1"/>
              </tr>
            </thead>
          </div>
          <hr>
          <tbody>
            <draggable v-model="tmp.myDisp" :options="{ handle: '.drag-handle' }" item-key="id">
              <template #item="{element, index}">
                <tr
                  :style="(index % 2 == 1) ? { 'background-color': '#f3f3f3' } : ''"
                  class="dialog-tr grid gap-x-2 grid-cols-12 justify-items-auto py-2">
                  <!-- ドラッグアイコン -->
                  <td class="drag-handle col-span-1 justify-self-center self-center flex-1"><svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z" />
                  </svg></td>
                  <!-- 表示する項目 -->
                  <div class="col-span-3">
                    <td>
                      <el-select
                        :name="`item${index}`"
                        v-model="element.item"
                        placeholder="選択"
                        :class="`${element.errorMsg ? 'input-error' : ''}`">
                        <el-option
                          v-for="(item, key) in dialog.dispItemList" :key="`dIL_${key}`"
                          :label="item.label" :value="key" :disabled="item.disabled">
                        </el-option>
                      </el-select>
                      <template v-if="element.errorMsg">
                        <p class="form-error-text mt-1">{{ element.errorMsg }}</p>
                      </template>
                    </td>
                  </div>
                  <!-- 表示する条件 -->
                  <div class="col-span-3">
                    <td>
                      <el-select
                        v-if="element.item"
                        :name="`type${index}`"
                        v-model="element.condition.type"
                        placeholder="選択"
                        :class="`${element.condition.typeErrorMsg ? 'input-error' : ''}`">
                        <el-option
                          v-for="item in dialog.dispConditionList[`${ dialog.dispItemList[element.item].type }`]"
                          :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <template v-if="element.condition.typeErrorMsg">
                        <p class="form-error-text mt-1">{{ element.condition.typeErrorMsg }}</p>
                      </template>
                    </td>
                  </div>
                  <!-- 表示する条件 詳細 -->
                  <div class="col-span-4">
                    <td>
                      <template v-if="element.item && element.condition.type == 'over'
                        || element.item && element.condition.type == 'less'
                        || element.item && element.condition.type == 'equal'
                        || element.item && element.condition.type == 'include'">
                        <input
                          v-model="element.condition.value"
                          :name="`value${index}`"
                          placeholder="入力"
                          :class="`screener-input ${element.condition.valueErrorMsg ? 'border-red-500' : 'border-gray-300'}`"
                        >
                        <template v-if="element.condition.valueErrorMsg">
                          <p class="form-error-text mt-1">{{ element.condition.valueErrorMsg }}</p>
                        </template>
                      </template>
                      <template v-if="element.item && element.condition.type == 'select'">
                        <el-select v-model="element.condition.value" placeholder="選択">
                          <el-option
                            v-for="item in nikkeiSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </template>
                    </td>
                  </div>
                  <div class="col-span-1 justify-self-end mr-5">
                    <td>
                      <el-button type="danger" @click="removeItem(index)" circle plain><svg style="width:16px;height:20px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,13H5V11H19V13Z" />
                      </svg></el-button>
                    </td>
                  </div>
                </tr>
              </template>
            </draggable>
          </tbody>
        </table>
      </div>
      <!-- ダイアログ フッター -->
      <span>
        <div class="row flex justify-end pt-5">
          <el-button type="success" icon="el-icon-plus" @click="addItem()" plain round><svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
          </svg>項目を追加する</el-button>
          <el-button :type="(this.dialog.isDispChange || this.dialog.isSortChange) ? 'warning' : 'success'" @click="execScreeningSave()" plain round>
            <i v-show="screeningLoading" class="el-icon-loading"/>
            <i v-show="!screeningLoading" class="el-icon-refresh"/>
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z" />
            </svg>&nbsp;スクリーニングを実行する
          </el-button>
          <el-button type="danger" @click="reset()" plain round>全件表示</el-button>
        </div>
      </span>
    </el-dialog>
  
  </section>
</template>
<script>
import { axios } from '@/plugins/axios'
import draggable from 'vuedraggable'

export default {
  name: 'brand-screener',
  components: {
    draggable
  },
  data() {
    return {
      loading: false,
      loadingPercent: 0,
      screeningLoading: false,
      // *--- 取得データ ---*
      base: { stockData: '' }, // フィルター前全件
      filtered: { stockData: '' }, // フィルター後全件
      table: { stockData: [] }, // テーブル表示用
      // *--- テーブル調整用 ---*
      pageSize: 20,
      pageCurrent: 1,
      tableMaxHeight: 800,
      // *--- ダイアログ ---*
      dialog: {
        visible: false,
        isDispChange: false,
        isSortChange: false,
        // 並び替える項目 -> computed.
        // 並び替える順序
        sortOrderList: [
          { value: 'asc', label: '昇順' },
          { value: 'desc', label: '降順' },
        ],
        // 表示する項目
        dispItemList: {
          code: { require: true, type: 'text', disabled: false, label: 'コード', head: 'ｺｰﾄﾞ' }, // 表示上はテキスト扱い
          brand_name: { require: true, type: 'text', disabled: false, label: '会社名', head: '会社名' },
          industry_type: { require: false, type: 'text', disabled: false, label: '業種', head: '業種' },
          market_size: { require: false, type: 'numeric', disabled: false, label: '売買代金', head: '売買代金' },
          per: { require: false, type: 'numeric', disabled: false, label: 'PER', head: 'PER' },
          pbr: { require: false, type: 'numeric', disabled: false, label: 'PBR', head: 'PBR' },
          roe: { require: false, type: 'numeric', disabled: false, label: 'ROE', head: 'ROE' },
          dividend_yield: { require: false, type: 'numeric', disabled: false, label: '配当利回り', head: '配当利回り' },
          close: { require: false, type: 'numeric', disabled: false, label: '終値', head: '終値' },
          stage: { require: false, type: 'numeric', disabled: false, label: 'ステージ', head: 'ｽﾃｰｼﾞ' },
          total4: { require: false, type: 'numeric', disabled: false, label: '4合計', head: '4合計' },
          total6: { require: false, type: 'numeric', disabled: false, label: '6合計', head: '6合計' },
          trend_appear: { require: false, type: 'numeric', disabled: false, label: 'トレンド出現', head: 'ﾄﾚﾝﾄﾞ出現' },
          trend_continue: { require: false, type: 'numeric', disabled: false, label: 'トレンド継続', head: 'ﾄﾚﾝﾄﾞ継続' },
          counting: { require: false, type: 'numeric', disabled: false, label: 'カウンティング', head: 'ｶｳﾝﾃｨﾝｸﾞ' },
          price_fluctuation: { require: false, type: 'numeric', disabled: false, label: '価格変動', head: '価格変動' },
          window: { require: false, type: 'numeric', disabled: false, label: '窓', head: '窓' },
          mustache: { require: false, type: 'numeric', disabled: false, label: 'ヒゲ', head: 'ヒゲ' },
          nikkei225: { require: false, type: 'boolean', disabled: false, label: '日経225', head: '日経225' },
          nikkei400: { require: false, type: 'boolean', disabled: false, label: '日経400', head: '日経400' },
          margin_trading_type: { require: false, type: 'text', disabled: false, label: '貸借区分', head: '貸借区分' },
          break_upper: { require: false, type: 'boolean', disabled: false, label: '直近3ヶ月の高値更新', head: '直近3ヶ月の高値更新' },
          ema20_gt_ema200: { require: false, type: 'boolean', disabled: false, label: 'EMA20＞EMA200', head: 'EMA20＞EMA200' },
          vsma_100k: { require: false, type: 'boolean', disabled: false, label: '出来高10万株以上', head: '出来高10万株以上' },
          trend_continue_upper: { require: false, type: 'numeric', disabled: false, label: 'トレンド継続（買いのみ）', head: 'トレンド継続（買いのみ）' },
          inc_4q_sales: { require: false, type: 'boolean', disabled: false, label: '四半期売上 4期連続増', head: '四半期売上 4期連続増' },
          inc_3q_sales: { require: false, type: 'boolean', disabled: false, label: '四半期売上 3期連続増', head: '四半期売上 3期連続増' },
          inc_2q_sales: { require: false, type: 'boolean', disabled: false, label: '四半期売上 2期連続増', head: '四半期売上 2期連続増' },
          inc_1q_sales: { require: false, type: 'boolean', disabled: false, label: '四半期売上 1期増', head: '四半期売上 1期増' },
          inc_4q_eps: { require: false, type: 'boolean', disabled: false, label: '四半期EPS 4期連続増', head: '四半期EPS 4期連続増' },
          inc_3q_eps: { require: false, type: 'boolean', disabled: false, label: '四半期EPS 3期連続増', head: '四半期EPS 3期連続増' },
          inc_2q_eps: { require: false, type: 'boolean', disabled: false, label: '四半期EPS 2期連続増', head: '四半期EPS 2期連続増' },
          inc_1q_eps: { require: false, type: 'boolean', disabled: false, label: '四半期EPS 1期増', head: '四半期EPS 1期増' },
        },
        // 表示する条件
        dispConditionList: {
          numeric: [
            { value: 'all', label: 'すべて' },
            { value: 'over', label: '以上' },
            { value: 'less', label: '以下' },
            { value: 'equal', label: '等しい' },
          ],
          text: [
            { value: 'all', label: 'すべて' },
            { value: 'include', label: '含む' },
            { value: 'equal', label: '完全一致' },
          ],
          boolean: [
            { value: 'all', label: 'すべて' },
            { value: 'select', label: '選択' },
          ]
        }
      },
      // *--- 自分の設定 保存データ ---*
      save: {
        mySort: [],
        myDisp: [],
      },
      // *--- 自分の設定 一時データ ---*
      tmp: {
        mySort: [],
        myDisp: [],
      },
      // *--- 日経225、400の選択フォーム用 ---*
      nikkeiSelect: [{
        value: '1',
        label: '●'
      }, {
        value: '0',
        label: '-'
      }],
    }
  },
  computed: {
    // *--- データ長 ---*
    filtered_stockDataLength() {
      return this.filtered.stockData.length
    },
    myDispTmpLength() {
      return this.tmp.myDisp.length
    },
    myDispSaveLength() {
      return this.save.myDisp.length
    },
    pageStart() {
      if (this.pageCurrent == 1) {
        return 1
      } else {
        return (this.pageCurrent - 1) * this.pageSize + 1
      }
    },
    pageEnd() {
      let end = this.pageCurrent * this.pageSize
      if (end > this.filtered_stockDataLength) {
        end = this.filtered_stockDataLength
      }
      return end
    },
    tableStockData() {
      return this.filtered.stockData.slice(this.pageStart - 1, this.pageEnd)
    },
    getResponsive() {
      return (window.innerWidth > 768) ? 'sm' : 'xs'
    },
    // *--- 並び替える項目 ---*
    sortItemList() {
      const result = []
      // 自分で選んだ表示する項目が並び替え項目としても使える
      Object.keys(this.tmp.myDisp).forEach(key => {
        if (this.tmp.myDisp[key].item) {
          result.push({
            value: this.tmp.myDisp[key].item,
            label: this.dialog.dispItemList[this.tmp.myDisp[key].item].label
          })
        }
      })
      return result
    },
    // *--- ドラッグ並び替え用 ---*
    dragMyDisp: {
      get() {
        return this.tmp.myDisp
      },
      set(value) {
        this.tmp.myDisp = value
      }
    },
    // *--- テーブル幅 ---*
    widthCell() {
      if (this.getResponsive == 'sm') {
        return {
          'code': 80,
          'brand_name': 450,
          'industry_type': 250,
          'market_size': 230,
          'per': 100,
          'pbr': 100,
          'roe': 140,
          'dividend_yield': 130,
          'close': 100,
          'stage': 80,
          'total4': 100,
          'total6': 100,
          'trend_appear': 125,
          'trend_continue': 125,
          'counting': 120,
          'price_fluctuation': 110,
          'window': 80,
          'mustache': 80,
          'nikkei225': 90,
          'nikkei400': 90,
          'margin_trading_type': 170,
          'break_upper': 200,
          'ema20_gt_ema200': 200,
          'vsma_100k': 200,
          'trend_continue_upper': 230,
          'inc_4q_sales': 200,
          'inc_3q_sales': 200,
          'inc_2q_sales': 200,
          'inc_1q_sales': 200,
          'inc_4q_eps': 200,
          'inc_3q_eps': 200,
          'inc_2q_eps': 200,
          'inc_1q_eps': 200,
        }
      } else {
        return {
          'code': 60,
          'brand_name': 400,
          'industry_type': 200,
          'market_size': 180,
          'per': 80,
          'pbr': 80,
          'roe': 100,
          'dividend_yield': 120,
          'close': 80,
          'stage': 70,
          'total4': 80,
          'total6': 80,
          'trend_appear': 105,
          'trend_continue': 105,
          'counting': 100,
          'price_fluctuation': 100,
          'window': 80,
          'mustache': 80,
          'nikkei225': 90,
          'nikkei400': 90,
          'margin_trading_type': 170,
          'break_upper': 100,
          'ema20_gt_ema200': 100,
          'vsma_100k': 100,
          'trend_continue_upper': 100,
          'inc_4q_sales': 100,
          'inc_3q_sales': 100,
          'inc_2q_sales': 100,
          'inc_1q_sales': 100,
          'inc_4q_eps': 100,
          'inc_3q_eps': 100,
          'inc_2q_eps': 100,
          'inc_1q_eps': 100,
        }
      }
    }
  },
  watch: {
    // *--- 変更監視および選択リスト すでに選ばれたものはDisable ---*
    'tmp.myDisp': {
      handler(data) {
        this.dialog.isDispChange = false
        if (this.myDispTmpLength != this.myDispSaveLength) {
          this.dialog.isDispChange = true
        } else {
          Object.keys(data).forEach(key => {
            if (data[key].item !== this.save.myDisp[key].item) {
              this.dialog.isDispChange = true
            }
            if (data[key].condition.type !== this.save.myDisp[key].condition.type) {
              this.dialog.isDispChange = true
            }
            if (data[key].condition.value !== this.save.myDisp[key].condition.value) {
              this.dialog.isDispChange = true
            }
          })
        }
        this.listDisabledCtl(data)
      },
      deep: true
    },
    'tmp.mySort': {
      handler(data) {
        this.dialog.isSortChange = false
        if (data.item !== this.save.mySort.item) {
          this.dialog.isSortChange = true
        }
        if (data.order !== this.save.mySort.order) {
          this.dialog.isSortChange = true
        }
      },
      deep: true
    },
  },
  async created() {
    this.loading = true

    await this.fetchData() // 株データ取得

    this.listDisabledCtl(this.tmp.myDisp) // 選択リスト すでに選ばれたものはDisable

    this.execScreening() // スクリーニング実行

    this.loading = false
  },
  methods: {
    // *--- 株データ取得 ---*
    async fetchData() {
      await axios
        .get('/screener-tool/fetch-data-screener')
        .then(async res => {
          // 株データ
          this.base.stockData = res.data.stock
          for (let index = 0; index < this.base.stockData.length; index++) {
            this.base.stockData[index].dividend_yield = parseFloat(this.base.stockData[index].dividend_yield)
            this.base.stockData[index].per = parseFloat(this.base.stockData[index].per)
            this.base.stockData[index].pbr = parseFloat(this.base.stockData[index].pbr)
            this.base.stockData[index].roe = parseFloat(this.base.stockData[index].roe)
          }
          // 保存データセットorデフォルトセット
          if (res.data.save) {
            this.save.mySort = res.data.save.my_sort
            this.save.myDisp = res.data.save.my_disp
            // 値渡し
            this.tmp.mySort = Object.assign({}, this.save.mySort)

            //新環境のバリデーション未設定による対応
            this.save.myDisp = this.save.myDisp.filter(v => v.item !== null)

            this.tmp.myDisp = JSON.stringify(this.save.myDisp)
            this.tmp.myDisp = JSON.parse(this.tmp.myDisp)
          } else {
            this.save.mySort = this.mySortDefaultSet()
            this.save.myDisp = this.myDispDefaultSet()
            this.tmp.mySort = this.mySortDefaultSet()
            this.tmp.myDisp = this.myDispDefaultSet()
          }
        })
        .catch(error => {
          if (error.response.data.status !== 'nodata') {
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message: '情報を取得できませんでした。<br>' + error.response.data.status
            })
          }
        })
    },
    // *--- ページネーション ---*
    pageSizeChange(val) {
      this.pageSize = val
      this.tableMaxHeight = val * 40
      // サイズ変更でページ位置は1に戻す
      this.pageCurrent = 1
    },
    pageCurrentChange(val) {
      this.pageCurrent = val
    },
    // *--- 選択リスト すでに選ばれたものはDisable ---*
    listDisabledCtl(data) {
      Object.keys(this.dialog.dispItemList).forEach(idx => {
        this.dialog.dispItemList[idx].disabled = false
      })
      data.forEach(mylist => {
        if (mylist.item) {
          this.dialog.dispItemList[`${mylist.item}`].disabled = true
        }
      })
    },
    // *--- 表示条件デフォルト ---*
    myDispDefaultSet() {
      return [
        { item: 'code', condition: { type: 'all', value: '' } },
        { item: 'brand_name', condition: { type: 'all', value: '' } },
        { item: 'close', condition: { type: 'all', value: '' } },
        { item: 'stage', condition: { type: 'all', value: '' } },
        { item: 'trend_appear', condition: { type: 'all', value: '' } },
        { item: 'trend_continue', condition: { type: 'all', value: '' } },
        { item: 'counting', condition: { type: 'all', value: '' } },
        { item: 'price_fluctuation', condition: { type: 'all', value: '' } },
        { item: 'window', condition: { type: 'all', value: '' } },
        { item: 'mustache', condition: { type: 'all', value: '' } },
        { item: 'total6', condition: { type: 'all', value: '' } },
        { item: 'market_size', condition: { type: 'over', value: 50000000 } },
        { item: 'per', condition: { type: 'less', value: 60 } },
        { item: 'pbr', condition: { type: 'all', value: '' } },
        { item: 'roe', condition: { type: 'over', value: 5 } },
        { item: 'dividend_yield', condition: { type: 'over', value: 0 } },
        { item: 'nikkei225', condition: { type: 'all', value: '' } },
        { item: 'nikkei400', condition: { type: 'all', value: '' } },
        { item: 'margin_trading_type', condition: { type: 'all', value: '' } },
        { item: 'break_upper', condition: { type: 'all', value: '' } },
        { item: 'ema20_gt_ema200', condition: { type: 'all', value: '' } },
        { item: 'vsma_100k', condition: { type: 'all', value: '' } },
        { item: 'trend_continue_upper', condition: { type: 'all', value: '' } },
        { item: 'inc_4q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_3q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_2q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_1q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_4q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_3q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_2q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_1q_eps', condition: { type: 'all', value: '' } },
      ]
    },
    allDispSet() {
      return [
        { item: 'code', condition: { type: 'all', value: '' } },
        { item: 'brand_name', condition: { type: 'all', value: '' } },
        { item: 'industry_type', condition: { type: 'all', value: '' } },
        { item: 'close', condition: { type: 'all', value: '' } },
        { item: 'stage', condition: { type: 'all', value: '' } },
        { item: 'trend_appear', condition: { type: 'all', value: '' } },
        { item: 'trend_continue', condition: { type: 'all', value: '' } },
        { item: 'counting', condition: { type: 'all', value: '' } },
        { item: 'price_fluctuation', condition: { type: 'all', value: '' } },
        { item: 'window', condition: { type: 'all', value: '' } },
        { item: 'mustache', condition: { type: 'all', value: '' } },
        { item: 'total6', condition: { type: 'all', value: '' } },
        { item: 'market_size', condition: { type: 'all', value: '' } },
        { item: 'per', condition: { type: 'all', value: '' } },
        { item: 'pbr', condition: { type: 'all', value: '' } },
        { item: 'roe', condition: { type: 'all', value: '' } },
        { item: 'dividend_yield', condition: { type: 'all', value: '' } },
        { item: 'nikkei225', condition: { type: 'all', value: '' } },
        { item: 'nikkei400', condition: { type: 'all', value: '' } },
        { item: 'margin_trading_type', condition: { type: 'all', value: '' } },
        { item: 'break_upper', condition: { type: 'all', value: '' } },
        { item: 'ema20_gt_ema200', condition: { type: 'all', value: '' } },
        { item: 'vsma_100k', condition: { type: 'all', value: '' } },
        { item: 'trend_continue_upper', condition: { type: 'all', value: '' } },
        { item: 'inc_4q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_3q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_2q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_1q_sales', condition: { type: 'all', value: '' } },
        { item: 'inc_4q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_3q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_2q_eps', condition: { type: 'all', value: '' } },
        { item: 'inc_1q_eps', condition: { type: 'all', value: '' } },
      ]
    },
    // *--- スクリーニング実行 ---*
    execScreening() {
      // 表示項目と条件の処理
      const dispProcess = () => {
        let array = []
        Object.keys(this.base.stockData).forEach(baseKey => {
          let obj = new Object()

          obj.code = this.base.stockData[baseKey].code
          obj.brand_name = this.base.stockData[baseKey].brand_name

          let skip = 0
          
          Object.keys(this.tmp.myDisp).forEach(listKey => {
            // フィルター処理
            if (skip) { return }
            switch (this.tmp.myDisp[listKey].condition.type) {
            case 'all':
              break
            case 'over':
              if (this.base.stockData[baseKey][this.tmp.myDisp[listKey].item] < this.tmp.myDisp[listKey].condition.value) {
                skip += 1; return
              }
              break
            case 'less':
              if (this.base.stockData[baseKey][this.tmp.myDisp[listKey].item] > this.tmp.myDisp[listKey].condition.value) {
                skip += 1; return
              }
              break
            case 'equal':
              if (this.base.stockData[baseKey][this.tmp.myDisp[listKey].item] != this.tmp.myDisp[listKey].condition.value) {
                skip += 1; return
              }
              break
            case 'include':
              if (!(this.base.stockData[baseKey][this.tmp.myDisp[listKey].item] === null)){
                if (this.base.stockData[baseKey][this.tmp.myDisp[listKey].item].indexOf(this.tmp.myDisp[listKey].condition.value) == -1) {
                  skip += 1; return
                }
              } else {
                skip += 1; return
              }
              break
            case 'select':
              if (this.base.stockData[baseKey][this.tmp.myDisp[listKey].item] != this.tmp.myDisp[listKey].condition.value) {
                skip += 1; return
              }
              break
            }
            obj[this.tmp.myDisp[listKey].item] = this.base.stockData[baseKey][this.tmp.myDisp[listKey].item]
          })
          if (skip) { return }
          array.push(obj)
        })
        return array
      }
      // 並び替え処理
      const sortProcess = () => {
        let data = this.filtered.stockData
        const key = this.tmp.mySort.item
        const order = this.tmp.mySort.order
        //デフォは降順(DESC)
        let num_a = -1
        let num_b = 1

        if (order === 'asc') { //指定があれば昇順(ASC)
          num_a = 1
          num_b = -1
        }

        data.sort((a, b) => {
          let x = a[key]
          let y = b[key]
          if (x > y) return num_a
          if (x < y) return num_b
          return 0
        })
      }

      this.filtered.stockData = dispProcess() // フィルターされたもの全件、ダウンロード処理にも利用
      sortProcess()
    },
    execScreeningSaveValidate() {
      // execScreeningSave関数のバリデーションをif文でゴリゴリに実装する
      let isError = false
      this.tmp.myDisp = this.tmp.myDisp.map((myDisp) => {
        if (! myDisp.item) {
          myDisp.errorMsg = '選択して下さい'
          isError = true
        } else {
          delete myDisp.errorMsg
          if (! myDisp.condition.type) {
            myDisp.condition.typeErrorMsg = '選択して下さい'
            isError = true
          } else {
            delete myDisp.condition.typeErrorMsg
            if (myDisp.condition.type != 'all') {
              if (myDisp.condition.value === '') {
                myDisp.condition.valueErrorMsg = '必須です'
                isError = true
              } else {
                delete myDisp.condition.valueErrorMsg
              }
            }
          }
        }

        return myDisp
      })
      return isError
    },
    // *--- スクリーニングを実行しつつ保存 ---*
    async execScreeningSave() {
      const isError = this.execScreeningSaveValidate()

      if (isError) {
        // バリデーションエラーの場合ここで処理を終わらせる
        return
      }

      this.screeningLoading = true

      this.execScreening() // スクリーニング
      this.save.mySort = Object.assign({}, this.tmp.mySort)
      this.save.myDisp = JSON.stringify(this.tmp.myDisp)
      this.save.myDisp = JSON.parse(this.save.myDisp)
      const sdata = {
        my_sort: this.save.mySort,
        my_disp: this.save.myDisp
      }
      await axios
        .post('/screener-tool/save-screener/', sdata)
        .then(res => {
          this.$message.success('保存しました。')
        })
        .catch(error => {
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message:
                  '保存できませんでした。<br>' + error.response.data.status
          })
        })

      this.screeningLoading = false
      this.dialog.visible = false
      this.dialog.isDispChange = false
      this.dialog.isSortChange = false
      return
    },
    async reset() {
      const allDisp = async() => {
        this.save.mySort = this.mySortDefaultSet()
        this.save.myDisp = this.allDispSet()
        const sdata = {
          my_sort: this.save.mySort,
          my_disp: this.save.myDisp
        }
        await axios
          .post('/screener-tool/save-screener/', sdata)
          .then(res => {
            //
          })
          .catch(error => {
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message:
                    '保存できませんでした。<br>' + error.response.data.status
            })
          })
      }

      this.$confirm('表示項目と条件をリセットします。<br>よろしいですか？', {
        dangerouslyUseHTMLString: true
      })
        .then(async () => {
          await allDisp()
          this.dialog.visible = false
          this.dialog.isDispChange = false
          this.dialog.isSortChange = false
          this.tmp.mySort = this.mySortDefaultSet()
          this.tmp.myDisp = this.allDispSet()
          this.listDisabledCtl(this.tmp.myDisp) // 選択リスト すでに選ばれたものはDisable
          this.execScreening()
          this.$message.success('保存しました。')
        })
        .catch(_ => {
          console.log('error')
        })
    },
    // *--- ダイアログ閉じチェック ---*
    dialogClose() {
      // スクリーニング実行中の閉じる動作
      if (this.screeningLoading) {
        return
      }

      if (this.dialog.isDispChange || this.dialog.isSortChange) {
        this.$confirm('変更中の設定を破棄します。<br>このまま閉じますか？', {
          dangerouslyUseHTMLString: true
        })
          .then(_ => {
            this.tmp.mySort = Object.assign({}, this.save.mySort)
            this.tmp.myDisp = JSON.stringify(this.save.myDisp)
            this.tmp.myDisp = JSON.parse(this.tmp.myDisp)
            this.dialog.visible = false
            // done()
          })
          .catch(_ => {
            console.log('error')
          })
      } else {
        this.dialog.visible = false
      }
    },
    // *--- 項目の追加・削除 ---*
    addItem() {
      this.tmp.myDisp.push(
        { item: '', condition: { type: '', value: '' } }
      )
    },
    removeItem(index) {
      // 並び替える項目で洗濯していたものが消された場合
      if (this.tmp.myDisp[index].item == this.tmp.mySort.item) {
        this.tmp.mySort.item = 'code'
      }
      // 削除
      this.tmp.myDisp.splice(index, 1)
    },
    // *--- 数値にカンマを付与 ---*
    moneyDelimiter(value) {
      // return value.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      if (!isFinite(value)) { return value }
      return value.toLocaleString()
    },
    // *--- 日経225、400表示設定 ---*
    nikkeiDisp(value) {
      return value ? '●' : '-'
    },
    // *--- テーブルセル表示調整 ---*
    cellValue(key, value) {
      switch (key) {
      case 'close':
      case 'market_size':
        value = this.moneyDelimiter(value); break
      case 'break_upper':
        value = this.nikkeiDisp(value); break
      case 'ema20_gt_ema200':
        value = this.nikkeiDisp(value); break
      case 'vsma_100k':
        value = this.nikkeiDisp(value); break
      case 'roe':
      case 'dividend_yield':
        value = value + '％'; break
      case 'nikkei225':
        value = this.nikkeiDisp(value); break
      case 'nikkei400':
        value = this.nikkeiDisp(value); break
      case 'inc_4q_sales':
      case 'inc_3q_sales':
      case 'inc_2q_sales':
      case 'inc_1q_sales':
        value = this.nikkeiDisp(value); break
      case 'inc_4q_eps':
      case 'inc_3q_eps':
      case 'inc_2q_eps':
      case 'inc_1q_eps':
        value = this.nikkeiDisp(value); break
      }
      return value
    },
    // *--- テーブルセルクラス調整 ---*
    getCellClass(rows) {
      const key = this.save.myDisp[rows.columnIndex].item
      const value = rows.row[key]
      const heatClass = this.pickHeatMapColor(key, value)
      return `${heatClass} el-table-row-height`
    },
    // *--- 並び条件デフォルト ---*
    mySortDefaultSet() {
      return { item: 'total6', order: 'desc' }
      // return { item: 'trend_continue_upper', order: 'desc' } //チャーメンではトレンド継続（買いのみ）の降順で表示
    },
    // *--- ヒートマップ ---*
    pickHeatMapColor(item, value) {
      switch (item) {
      case 'code':
      case 'brand_name':
      case 'industry_type':
      case 'market_size':
      case 'per':
      case 'pbr':
      case 'roe':
      case 'dividend_yield':
      case 'close':
      case 'stage':
      case 'nikkei225':
      case 'nikkei400':
      case 'margin_trading_type':
      case 'break_upper':
      case 'ema20_gt_ema200':
      case 'inc_4q_sales':
      case 'inc_3q_sales':
      case 'inc_2q_sales':
      case 'inc_1q_sales':
      case 'inc_4q_eps':
      case 'inc_3q_eps':
      case 'inc_2q_eps':
      case 'inc_1q_eps':
      case 'vsma_100k':
        return 
      case 'total4':
        value /= 4; break
      case 'total6':
        value /= 6; break
      }
      // classはapp.scss参照
      switch (true) {
      case !value:
        return
      case value < 20:
        return 'bg-red-400' 
      case 20 <= value && value < 30:
        return 'bg-red-300' 
      case 30 <= value && value < 40:
        return 'bg-red-200' 
      case 40 <= value && value < 50:
        return 'bg-red-100' 
      case value > 80:
        return 'bg-green-400' 
      case 70 < value && value <= 80:
        return 'bg-green-300' 
      case 60 < value && value <= 70:
        return 'bg-green-200' 
      case 50 < value && value <= 60:
        return 'bg-green-100' 
      default:
        return 'heatDefault' 
      }
    },
    // *--- DOWNLOAD ---*
    async dataDownload(command) {
      let stock = ''
      if (command === 'all') {
        stock = this.filtered.stockData
      } else {
        stock = this.filtered.stockData.slice(this.pageStart - 1, this.pageEnd)
      }
      let txtData = ''
      Object.keys(stock).forEach(key => {
        txtData += (key == stock.length - 1)
          ? 'TSE:' + stock[key].code
          : 'TSE:' + stock[key].code + '\r\n'
      })
      // ファイルタイプ、保存するテキストを指定してblobを作成
      const blob = new Blob([ txtData ], {
        'type': 'text/plain'
      })
      // タイムスタンプ生成
      const date = new Date()
      const timeStamp = Math.floor(date.getTime() / 1000)
      // ダウンロード
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `codelist_${timeStamp}.txt`
      link.click()
      // 空にする
      stock = null
      txtData = null
    },
  },
}
</script>

<style scope>
.screener-input {
@apply appearance-none w-full py-1.5 px-2 text-gray-600 leading-tight border rounded border-solid focus:border-blue-600 focus:outline-none;
}
.drag-handle {
  cursor: move;
}
</style>

<style>
#screener .input-error .el-input__wrapper {
  border: solid 1px rgb(239, 68, 68) !important;
  box-shadow: initial !important;
}
</style>
